function isExpiredLinkError(error) {
  if ("error" in error) {
    const description = error.error_description || error.errorDescription;
    if (description?.toLowerCase().includes("the verification code has expired")) {
      return true;
    }
    if (description?.toLowerCase().includes("wrong email or verification code")) {
      return true;
    }
  }
  return false;
}
export {
  isExpiredLinkError
};
//# sourceMappingURL=is-expired-link-error.js.map
